module.exports = __webpack_public_path__ + "img/content7.ceb40069.png";